var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-stretch h-100",attrs:{"id":"layout-container"}},[_c('sidebar'),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column flex-grow-1 bg-extra-light-gray",staticStyle:{"min-width":"0"}},[_c('topbar'),_vm._v(" "),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }